import { WpRendererError } from '@waypoint/templates';

import { useRenderLiquid } from '../WaypointRendererStore';

const COLOR_REGEXP = /^\s*(#[a-zA-Z0-9]{6})\s*$/;

type TemplatedColorProps = {
  color: string | null | undefined;
  template: string | null | undefined;
  defaultColor: string;
};
export default function useTemplatedColor({ color, template, defaultColor }: TemplatedColorProps) {
  const evaluateLiquid = useRenderLiquid();
  let result = defaultColor;
  if (typeof color === 'string' && color.trim().length > 0) {
    result = color;
  }

  if (typeof template === 'string') {
    try {
      const res = evaluateLiquid(template) ?? '';
      const match = res.match(COLOR_REGEXP);
      if (match) {
        result = match[1];
      }
    } catch (e) {
      if (!(e instanceof WpRendererError)) {
        throw e;
      }
    }
  }
  return result;
}
